import React from 'react'
import { Link, graphql } from 'gatsby'
import get from 'lodash/get'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'

import Seo from '../components/seo'
import Layout from '../components/layout'
import * as styles from './blog-post.module.css'
import { GatsbyImage } from 'gatsby-plugin-image'

class BlogPostTemplate extends React.Component {
  
  render() {
    const post = get(this.props, 'data.contentfulMedewerker')
    const previous = get(this.props, 'data.previous')
    const next = get(this.props, 'data.next')
    const plainTextDescription = documentToPlainTextString(
      JSON.parse(post.description.raw)
    )

    return (
      <Layout location={this.props.location}>
        <Seo
          title={post.title}
          description={plainTextDescription}
          image={`http:${post.heroImage.resize.src}`}
        />
        <div className='empty_box'></div>
        <GatsbyImage style={{maxWidth: '55rem', margin: '0 auto'}} image={post.heroImage?.gatsbyImageData}/>

        <div className={styles.container}>

          <div className={styles.article}>
            <h1>{post.title}</h1>
            <div className={styles.body}>
              {post.body?.raw && renderRichText(post.body)}
            </div>
            {(previous || next) && (
              <nav>
                <ul className={styles.articleNavigation}>
                  {previous && (
                    <li>
                      <Link to={`/blog/${previous.slug}`} rel="prev">
                        ← {previous.title}
                      </Link>
                    </li>
                  )}
                  {next && (
                    <li>
                      <Link to={`/blog/${next.slug}`} rel="next">
                        {next.title} →
                      </Link>
                    </li>
                  )}
                </ul>
              </nav>
            )}
          </div>
        </div>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug(
    $slug: String!
    $previousPostSlug: String
    $nextPostSlug: String
  ) {
    contentfulMedewerker(slug: { eq: $slug }) {
      slug
      title
      author {
        name
      }
      heroImage {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, width: 1280)
        resize(height: 630, width: 1200) {
          src
        }
      }
      body {
        raw
      }
      description {
        raw
      }
    }
    previous: contentfulMedewerker(slug: { eq: $previousPostSlug }) {
      slug
      title
    }
    next: contentfulMedewerker(slug: { eq: $nextPostSlug }) {
      slug
      title
    }
  }
`
